document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".wwa-item-video").forEach((videocontainer) => {
    const videoPopup = videocontainer.querySelector(".wwa-videopopup");
    const videoBtn = videocontainer.querySelector(".wwa-videobtn");
    const closeBtn = videocontainer.querySelector(".wwa-videoclosebtn");
    const overlay = videocontainer.querySelector(".videopopup-overlay");
    const videoContainers = videocontainer.querySelector(".video-wp"); // Use the correct container inside each item
    const video = videoContainers ? videoContainers.querySelector("video") : null;
    const iframe = videoContainers ? videoContainers.querySelector("iframe") : null;
    
    function openPopup() {
      videoPopup.classList.add("active");
      
      if (video) {
        video.play();
      } else if (iframe) {
        // Autoplay YouTube iframe
        let src = iframe.getAttribute("src");
        if (!src.includes("autoplay=1")) {
          iframe.setAttribute("src", src + (src.includes("?") ? "&" : "?") + "autoplay=0");
        }
      }
    }
    
    function closePopup() {
      videoPopup.classList.remove("active");

      if (video) {
        video.pause();
        video.currentTime = 0;
      } else if (iframe) {
        // Stop YouTube iframe by resetting src
        let src = iframe.getAttribute("src");
        iframe.setAttribute("src", ""); // Clear src to stop video
        iframe.setAttribute("src", src + (src.includes("?") ? "&" : "?") + "autoplay=0"); // Restore src
      }
    }

    videoBtn.addEventListener("click", openPopup);
    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);
  });

  document.querySelectorAll(".wwa-video-mute-unmutebtn").forEach((button) => {
    button.addEventListener("click", function () {
      const videoWrapper = this.closest(".video-wp");
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector("video");
      if (video) {
        video.muted = !video.muted;
        this.classList.toggle("muted");
      }
    });
  });
  document.querySelectorAll(".wwa-video-pause-playbtn").forEach((button) => {
    button.addEventListener("click", function () {
      const videoWrapper = this.closest(".video-wp");
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector("video");
      if (video) {
        if (video.paused) {
          video.play();
          this.classList.add("playing");
        } else {
          video.pause();
          this.classList.remove("playing");
        }
      }
    });
  });

  const grids = document.querySelectorAll(".cf-grid");
  grids.forEach((grid) => {
      const triggers = grid.querySelectorAll(".cf-trigger");
      triggers.forEach((trigger) => {
          trigger.addEventListener("click", function () {
              const content = this.nextElementSibling;
              const isOpen = content.classList.contains("open");
              grid.querySelectorAll(".cf-trigger").forEach((t) => t.classList.remove("open"));
              grid.querySelectorAll(".cf-content").forEach((c) => {
                  c.style.maxHeight = "0";
                  c.classList.remove("open");
              });
              if (!isOpen) {
                  this.classList.add("open");
                  content.classList.add("open");
                  content.style.maxHeight = content.scrollHeight + "px";
              }
          });
      });
  });
  const gridsBundled = document.querySelectorAll(".cf-grid-bundled");
  gridsBundled.forEach((grid) => {
      const triggersBundled = grid.querySelectorAll(".cf-trigger-bundled");
      triggersBundled.forEach((trigger) => {
          trigger.addEventListener("click", function () {
              const content = this.nextElementSibling;
              const isOpen = content.classList.contains("open");
              grid.querySelectorAll(".cf-trigger-bundled").forEach((t) => t.classList.remove("open"));
              grid.querySelectorAll(".cf-content-bundled").forEach((c) => {
                  c.style.maxHeight = "0";
                  c.classList.remove("open");
              });
              if (!isOpen) {
                  this.classList.add("open");
                  content.classList.add("open");
                  content.style.maxHeight = content.scrollHeight + "px";
              }
          });
      });
  });

  const chekTemplate = document.body.dataset.template;
 document.querySelectorAll(".custom-dropdown").forEach((dropdown) => {
    const idInput = dropdown.querySelector('[name="id"]');
    const addToCartForm = dropdown ? dropdown.closest("form") : null;
    const addToCartButton = addToCartForm ? addToCartForm.querySelector('[name="add"]') : null;
    const addToCartButtonText = addToCartButton ? addToCartButton.querySelector(".quickaddbtntext") : null;
    const button = dropdown.querySelector(".custom-dropdown-btn");
    const content = dropdown.querySelector(".custom-dropdown-content");
    const items = dropdown.querySelectorAll(".custom-dropdown-content li");
    let productContainer;

    if (chekTemplate === "product") {
      productContainer = dropdown.closest(".product__info-container");
    }

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      document
        .querySelectorAll(".custom-dropdown-content.show")
        .forEach((drop) => {
          if (drop !== content) drop.classList.remove("show");
        });
      content.classList.toggle("show");
    });

    items.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        if (idInput) {
          const oldValue = idInput.value;
          idInput.value = item.dataset.varid;

          // Disparar evento personalizado cuando cambia la variante
          if (oldValue !== item.dataset.varid) {
            document.dispatchEvent(new CustomEvent('variant:change', {
              detail: {
                variantId: item.dataset.varid,
                variant: { id: item.dataset.varid },
                previousVariantId: oldValue
              }
            }));
          }
        }
        
        if (addToCartForm && addToCartButton && addToCartButtonText) {
          if (item.dataset.variant_available === "false") {
            addToCartButton.disabled = true;
            addToCartButtonText.textContent = window.variantStrings.soldOut;
          } else {
            addToCartButton.disabled = false;
            addToCartButtonText.textContent = window.variantStrings.addToCart;
          }
        }
        if (chekTemplate === "product" && productContainer) {
          ["option1", "option2", "option3"].forEach((opt) => {
            const value = item.dataset[opt];
            if (value) {
              const optionEvent = productContainer.querySelector(
                `[data-${opt}] [data-${opt}="${value}"]`
              );
              if (optionEvent) optionEvent.click();
            }
          });
        }

        button.innerHTML = item.innerHTML;
        content.classList.remove("show");
      });
    });
  });

  document.addEventListener("click", () => {
    document
      .querySelectorAll(".custom-card .custom-dropdown-content.show")
      .forEach((drop) => drop.classList.remove("show"));
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product_banner_highlights-main').forEach((highlights) => {
    const buttons = highlights.querySelectorAll('.pbh-btn');
    const images = highlights.querySelectorAll('.pbh-img-wp');
    let currentIndex = 0;
    let interval;

    const activateButton = (index) => {
      buttons.forEach((btn, i) => btn.classList.toggle('active', i === index));
      images.forEach((img, i) => img.classList.toggle('active', i === index));
    };

    const startRotation = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % buttons.length;
        activateButton(currentIndex);
      }, 3000);
    };

    buttons.forEach((button, index) => {
      button.addEventListener('mouseenter', () => {
        clearInterval(interval);
        currentIndex = index;
        activateButton(currentIndex);
      });
      button.addEventListener('mouseleave', startRotation);
    });

    activateButton(currentIndex);
    startRotation();
  });
});


let productMedia;

const initFlickity = () => {
  const mediaList = document.querySelector(".product__media-list");

  if (!mediaList) return;

  if (productMedia) {
    productMedia.destroy();
  }

  productMedia = new Flickity(mediaList, {
    freeScroll: false,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true
  });
};

document.addEventListener("DOMContentLoaded", initFlickity);

function handleDropdownClick() {
  document.querySelectorAll(".custom-dropdown-content").forEach((content) => {
    content.classList.remove("show");
  });
}
// window.addEventListener("click", handleDropdownClick);

/**
 * Rebuy Widget - Convert all titles to H2
 * Widget ID: 244043 (Product Cross-Sell - Pair It With)
 * Maintains all visual styles (font-size, color, weight, etc.)
 *
 * Fixes heading hierarchy:
 * - H1: Product title
 * - H2: Description, Features, Reviews, Pair it with
 */
document.addEventListener("rebuy.ready", function() {
  // Selecciona todos los títulos h5 dentro del widget
  document.querySelectorAll('#rebuy-widget-244043  h5.rebuy-product-title')
    .forEach(el => {
      const newEl = document.createElement("h3");
      newEl.className = el.className;
      newEl.innerHTML = el.innerHTML;
      el.replaceWith(newEl);
    });
});

document.addEventListener('click', function (e) {

  const btn = e.target.closest('.ps-backtotop-btn');
  if (!btn) return;

  e.preventDefault();

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });

});


(function () {

  function setupFooterAccordion() {
    const isMobile = window.innerWidth <= 768;

    document.querySelectorAll('.footer-block--menu').forEach(block => {
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content');

      if (!heading || !content) return;

      // Always clean previous state (important)
      heading.removeEventListener('click', heading._clickHandler || (() => {}));

      content.style.maxHeight = '';
      content.style.overflow = '';
      content.style.transition = '';
      heading.style.cursor = '';

      if (isMobile) {
        // Collapse by default
        content.style.maxHeight = '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'max-height 0.3s ease';
        heading.style.cursor = 'pointer';

        // Create handler (store reference to remove later)
        const handler = function () {
          const isOpen = content.style.maxHeight !== '0px';

          // Close all blocks (accordion behavior)
          document.querySelectorAll('.footer-block--menu .footer-block__details-content').forEach(el => {
            el.style.maxHeight = '0px';
          });

          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        };

        heading._clickHandler = handler;
        heading.addEventListener('click', handler);
      }
    });
  }

  // Init
  document.addEventListener('DOMContentLoaded', setupFooterAccordion);

  // Fix for Shopify dynamic sections
  document.addEventListener('shopify:section:load', setupFooterAccordion);

  // Re-run on resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupFooterAccordion, 200);
  });

})();
